<template>
  <div v-if="ready">
    <div class="content-with-spacing">
      <div class="heading-container">
        <h1 v-if="slidesTitle">{{ slidesTitle }}</h1>
        <div class="heading-buttons">
          <span class="read-aloud-container">
            <a
              class="btn btn-outlined read-aloud-button"
              :href="assetUrl"
              target="_blank"
            >
              <i class="fas fa-external-link-alt" aria-hidden="true"></i> Read Aloud
            </a>
            <k-tooltip
              text="To make use of read-aloud functionality in your browser, click here to open this PDF in a new tab."
              trigger-label="More information about Read Aloud"
              text-align="large-tooltip"
            >
              <i class="fas fa-info-circle" aria-hidden="true"></i>
            </k-tooltip>
          </span>
          <module-asset-completion-button :asset="asset"></module-asset-completion-button>
          <intersection-observer observed-element="completion-buttons"
            @on-intersection-element="onElementInView"
          ></intersection-observer>
        </div>
      </div>
      <div class="slides-container panel panel-default">
        <iframe :data="assetUrl" type="application/pdf" :src="assetUrl" title="Slides display">
          <embed :src="assetUrl" type="application/pdf" />
        </iframe>
        <p class="slides-copyright-notice">
          © Cambridge Spark Ltd. Not for Redistribution.
        </p>
      </div>
      <div class="bottom-button-container" v-if="!isInViewElement">
        <module-asset-completion-button :asset="asset"></module-asset-completion-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.heading-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.read-aloud-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.read-aloud-button i {
  margin-right: 8px;
}

.slides-container {
  padding: 15px;
  height: 70vh;
  display: flex;
  flex-direction: column;
}

.slides-container.panel.panel-default iframe {
  display: flex;
  flex: 1;
  min-height: 0;
}

.category-header {
  margin-bottom: 20px;
}

.slides-copyright-notice {
  flex-shrink: 0;
  margin: 10px 0 0;
  font-size: 0.7rem;
  color: var(--kate-type-primary);
}

@media (max-width: 767px) {
  .slides-container.panel.panel-default iframe {
    width: 100%;
  }
}
</style>

<script>
import PageReadyMixin from '@mixins/page-ready-mixin';
import { KTooltip } from '@kate/components';
import IntersectionObserver from '@base-components/k-intersection-observer.vue';
import ModuleAssetCompletionButton from './module-asset-completion-button.vue';

export default {
  components: {
    ModuleAssetCompletionButton,
    KTooltip,
    IntersectionObserver,
  },

  mixins: [PageReadyMixin],

  props: {
    asset: {
      type: Object,
    },
    sidebarReady: {
      type: Boolean,
    },
  },

  data() {
    return {
      isInViewElement: false,
    };
  },

  computed: {
    ready() {
      return Boolean(this.asset && this.sidebarReady);
    },

    assetId() {
      return this.asset?.id;
    },

    slidesTitle() {
      return this.asset?.name;
    },
    assetUrl() {
      return `/api/static/slide_deck/${this.assetId}`;
    },
  },

  methods: {
    onElementInView(value) {
      this.isInViewElement = value;
    },
  },
};
</script>
